export const CheckoutListConfig = [
  {
    prop: 'internalName',
    name: 'Internal name',
  },
  {
    prop: 'name',
    name: 'Name',
  },
  {
    prop: 'conditions',
    name: 'Conditions',
  },
  {
    prop: 'rate',
    name: 'Rate',
  },
  {
    prop: 'actions',
    name: '',
  },
];
